const selectElementInArray = (array, element, isSelected) => {
  if (isSelected) {
    return [...array, element];
  }

  if (!isSelected) {
    return array.filter((existedElement) => existedElement !== element);
  }
};

export default selectElementInArray;
